import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_Mp3Converter = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/mp3-converter',
			name: 'MP3 Converter Online — Any Format, Instant Result by Lift',
			description:
				'Convert MP3 online — upload your file, pick an output format, and download the result in seconds. Supports MP4, MP3, MOV, MKV, WAV, and more. Try Lift now!',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/mp3-converter#product' },
				{ '@id': 'https://liftapp.ai/mp3-converter#howto' },
				{ '@id': 'https://liftapp.ai/mp3-converter#faq' },
				{ '@id': 'https://liftapp.ai/mp3-converter#why-lift' },
				{ '@id': 'https://liftapp.ai/mp3-converter#explore-tools' },
				{ '@id': 'https://liftapp.ai/mp3-converter#all-in-one' },
			],
		},
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/mp3-converter#product',
			name: 'MP3 Converter Online',
			description:
				'Convert audio and video files to MP3 and dozens of other formats. Upload your file, choose an output format, and download the result in seconds.',
			url: 'https://liftapp.ai/mp3-converter',
			fileFormat: [
				'audio/mpeg',
				'video/mp4',
				'video/quicktime',
				'audio/wav',
				'audio/flac',
				'audio/ogg',
			],
			memoryRequirements: 'Max file size: 2GB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/mp3-converter#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload Your File',
					text: 'Drop in any supported video format — MP4, MOV, AVI, MKV, WEBM, FLV, GIF, and more.',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Choose Your Output Format',
					text: 'Select from dozens of video and audio outputs — MP4, MP3, MOV, MKV, WAV, FLAC, OGG, AAC, and more.',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Lift Converts Your File',
					text: 'Lift processes your file with high-fidelity encoding, preserving resolution and audio quality.',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download the Result',
					text: 'Your converted file is ready instantly — download it for playback, editing, streaming, or sharing.',
				},
			],
		},
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/mp3-converter#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is the Lift MP3 Converter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift MP3 Converter is an online tool that converts video and audio files between dozens of formats in seconds. Upload your source file, choose an output format, and download the result.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does the Lift MP3 Converter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Upload your video or audio file in any supported format, then select the output format you need. Lift processes the file and delivers a converted result ready to download in seconds.',
					},
				},
				{
					'@type': 'Question',
					name: 'How long does MP3 conversion take?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Most conversions complete in seconds. Processing time depends on file size and output format, but Lift is optimized to deliver converted results as fast as possible — no waiting around.',
					},
				},
				{
					'@type': 'Question',
					name: 'Will converting a file affect its quality?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Lift uses high-fidelity encoding that preserves your file's original audio quality through conversion.",
					},
				},
				{
					'@type': 'Question',
					name: 'Is it safe to convert files with Lift?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift prioritizes your privacy — all files are processed securely and are not stored or shared after conversion. Your converted result is available only to you.',
					},
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/mp3-converter#why-lift',
			name: "Why Lift's MP3 Converter stands out",
			description:
				'High-quality results, intelligent rendering, cross-platform support, and budget-friendly pricing — Lift delivers professional-grade audio and video conversion.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade output every time.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the conversion to the file type for optimal results.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description:
						'Available on iOS, Android, and Web for seamless access.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly software with an affordable and intuitive tool.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl: 'https://liftapp.ai/images/mp3-converter/whyLift.webp',
				name: 'Lift MP3 Converter delivering high-quality output',
				description: "Lift's online MP3 converter in high resolution.",
			},
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/mp3-converter#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/mp3-converter#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},
		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'MP3 Converter',
					item: 'https://liftapp.ai/mp3-converter',
				},
			],
		},
	],
};
